// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--oLDOC";
export var title = "modal-module--title--ID88V";
export var body = "modal-module--body--5Swau";
export var image = "modal-module--image--wTrmo";
export var button = "modal-module--button--7G3lz";
export var fadein = "modal-module--fadein--+WciN";